angular.module("mobilezuz").factory("GMap", ["GoogleMapService", "GgMapMobileService", function(GoogleMapService, GgMapMobileService){
  var curGgMapSrv = window.cordova ? GgMapMobileService : GoogleMapService

  return curGgMapSrv;
}]);